import { Link } from '@inertiajs/react'
import { Users, Building2, Bot, Radio, Zap, Coins, CreditCard, DollarSign, ShieldCheck } from 'lucide-react'
import { StatCard } from '@/components/design-system/StatCard'
import { formatNumber, formatCurrency } from '@/frontend/pages/CommandCenter/Telemetry/utils'

interface SessionStats {
  activeSessions: number
  totalTokens: number
  totalCost: number
}

interface Kpis {
  totalUsers: number
  totalOrganizations: number
  totalDigitalWorkers: number
  trialOrganizations: number
  payingOrganizations: number
  agentsWithPlan: number
  monthlyRevenue: number
}

interface Props {
  kpis: Kpis
  sessionStats: SessionStats | null
}

export default function KpiRow({ kpis, sessionStats }: Props) {
  const loading = sessionStats === null

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        <Link href="/cc/users">
          <StatCard label="Usuários" value={formatNumber(kpis.totalUsers)} icon={<Users />} colorScheme="blue" size="small" />
        </Link>
        <Link href="/cc/telemetry">
          <StatCard label="Organizações" value={formatNumber(kpis.totalOrganizations)} icon={<Building2 />} colorScheme="gray" size="small" />
        </Link>
        <Link href="/cc/digital_workers">
          <StatCard label="Agentes Digitais" value={formatNumber(kpis.totalDigitalWorkers)} icon={<Bot />} colorScheme="green" size="small" />
        </Link>
        <StatCard label="Sessões Ativas" value={loading ? '...' : formatNumber(sessionStats.activeSessions)} icon={<Radio />} colorScheme="orange" size="small" loading={loading} />
        <StatCard label="Total de Tokens" value={loading ? '...' : formatNumber(sessionStats.totalTokens)} icon={<Zap />} colorScheme="violet" size="small" loading={loading} />
        <StatCard label="Custo Total" value={loading ? '...' : formatCurrency(sessionStats.totalCost)} icon={<Coins />} colorScheme="red" size="small" loading={loading} />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <StatCard label="Orgs em Trial" value={formatNumber(kpis.trialOrganizations)} icon={<ShieldCheck />} colorScheme="yellow" size="small" />
        <StatCard label="Orgs Pagantes" value={formatNumber(kpis.payingOrganizations)} icon={<CreditCard />} colorScheme="green" size="small" />
        <StatCard label="Agentes com Plano" value={formatNumber(kpis.agentsWithPlan)} icon={<Bot />} colorScheme="blue" size="small" />
        <StatCard label="Receita Mensal" value={formatCurrency(kpis.monthlyRevenue)} icon={<DollarSign />} colorScheme="purple" size="small" />
      </div>
    </div>
  )
}
